import { AnimatedSprite, Sprite } from 'pixi.js'
import { CustomPIXIComponent } from 'react-pixi-fiber'

export default CustomPIXIComponent({
  customDisplayObject(props) {
    const sprite = new AnimatedSprite([ new Sprite() ])
    sprite.anchor.set(0.5)
    sprite.loop = props.loop
    sprite.animationSpeed = 1

    sprite.position.set(props.x, props.y)

    sprite.defaultX = props.defaultX

    sprite.defaultY = props.defaultY

    if (props.flip) {
      sprite.scale.x = -1
    }

    return sprite
  },

  customApplyProps(displayObject, oldProps, newProps) {
    if (typeof newProps.textures !== 'undefined' && newProps.textures !== oldProps.textures) {
      const { textures } = newProps

      displayObject.texture = textures[0]
      displayObject.textures = textures
    }

    if (typeof newProps.x !== 'undefined' && newProps.x !== oldProps.x) {
      displayObject.position.x = newProps.x
    }

    if (typeof newProps.y !== 'undefined' && newProps.y !== oldProps.y) {
      displayObject.position.y = newProps.y
    }

    if (typeof newProps.frame !== 'undefined' && newProps.frame !== oldProps.frame) {
      displayObject.gotoAndStop(newProps.frame)
    }

    if (typeof newProps.onComplete !== 'undefined' && newProps.onComplete !== oldProps.onComplete) {
      displayObject.onComplete = newProps.onComplete
    }

    if (typeof newProps.animationSpeed !== 'undefined' && newProps.animationSpeed !== oldProps.animationSpeed) {
      displayObject.animationSpeed = newProps.animationSpeed
    }

    if (typeof newProps.alpha !== 'undefined' && newProps.alpha !== oldProps.alpha) {
      displayObject.alpha = newProps.alpha
    }

    if (newProps.play && newProps.play !== oldProps.play) {
      displayObject.play()
    }

    if (newProps.loop !== oldProps.loop) {
      displayObject.loop = newProps.loop
    }
  }
}, 'SpriteAnimation')
